export default __webpack_public_path__ + "static/media/ptx4.20c7d3cd.jpg";